import React from "react";
import { string } from "prop-types";

const RightArrowButton = ({ color = "#007bbd", color2 = "#ffffff" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42" enableBackground="new 0 0 42 42" width="42" height="42">
    <circle id="Ellipse_68" opacity="0.7" enableBackground="new" cx="21" cy="21" r="21" fill={color} />
    <g id="Path_51">
      <path
        fill={color2}
        d="M17.5,30.5c-0.256,0-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414l7.293-7.293l-7.293-7.293
		c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0l8.707,8.707l-8.707,8.707C18.012,30.402,17.756,30.5,17.5,30.5z"
      />
    </g>
  </svg>
);

RightArrowButton.propTypes = {
  color: string,
  color2: string,
};

export default RightArrowButton;
